export const getError = (state) => state.error.errorText;
